import { getSessionSetting, updateSessionSetting } from '../../../api/administration/sessionSettings/sessionSetting'
import ActivityIndicator from '../../../components/activity/ActivityIndicator'
import React from "react";

function SessionActions({ show, close, notify }) {

    const GetSessionSettingValue = async () => {
        show(() => <ActivityIndicator text={"Loading Session Settings"} />)
        const [error, data] = await getSessionSetting()
        close()
        if (error) {
            notify({ message: data?.status?.message, type: "E" });
            return [data?.status.messag, data];
        }
        if (data.code >= 400) {
            notify({ message: data?.message, type: "E" });
            return [data.message, data];
        }
        return [null, data];
    }


    const UpdateSessionSettingValue = async (input) => {
        show(() => <ActivityIndicator text={"Updating Session Settings"} />)
        const [error, data] = await updateSessionSetting(input)
        close()
        if (error) {
            notify({ message: data?.status?.message, type: "E" });
            return [data?.status.message, data];
        }
        if (data.status.code === 1) {
            notify({ message: data?.status?.message, type: "S" });
            return [data.status.message, data];
        }
        return [null, data];
    }

    return { GetSessionSettingValue, UpdateSessionSettingValue }
}

export default SessionActions